import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

/**
 * Fetch the admin-configured public support emails.
 *
 * Auth-free (calls /api/public/support-info). Cached for 10min — these
 * change very rarely. Returns { contact_email, sender_email } where each
 * field can be null when the admin hasn't configured it.
 */
export function useSupportInfo() {
  return useQuery({
    queryKey: ["public-support-info"],
    queryFn: async () => {
      const { data } = await api.get("/public/support-info");
      return data;
    },
    staleTime: 10 * 60 * 1000,
  });
}
